<!-- Modal Background -->
<div class="overflow-y-auto flex items-center justify-center">
  <!-- Modal Content -->
  <div class="w-full bg-white overflow-y-auto">
    <!-- Close Button -->
    <button (click)="closeModal()"
      class="absolute top-3 right-3 text-gray-600 hover:text-red-500 text-xl">&times;</button>

    <div class="flex flex-col md:flex-row justify-between gap-4">
      <!-- Left Section - Title and Description -->
      <div class="flex-1 min-w-0">
        <p class="text-xl font-semibold mb-2">{{item.supplier.name}}</p>
        <div class="flex flex-row items-center flex-wrap gap-2">
          <div class="flex items-center mr-1 text-gray-600">
            <mat-icon class="icon-size-4 text-gray-500">event</mat-icon>
            <div class="text-sm">
              {{item.date | date:'mediumDate'}} • {{item.date | date:'shortTime'}}
            </div>
          </div>
          <span class="text-gray-300">|</span>
          <!-- Location -->
          <div class="flex items-center mr-1">
            <mat-icon class="icon-size-4 text-gray-500">location_on</mat-icon>
            <span class="text-sm text-gray-500">{{item.supplier.place}}</span>
          </div>
          <span class="text-gray-300">|</span>
          <!-- Price -->
          <div class="flex items-center mr-1">
            <span class="text-xs text-gray-500 mr-1">From</span>
            <span class="text-md font-bold text-primary-500">
              {{item.priceAdvertise | currency:item.currency:'symbol-narrow'}}
            </span>
          </div>
        </div>
        <div class="text-sm text-gray-600 mt-2" [innerHTML]="item.supplier.contentShort"></div>
      </div>
    </div>

    <!-- Tickets -->
    <div class="py-8">
      <div class="bg-white rounded-lg w-full max-w-6xl mx-auto px-4 sm:px-6">
        <h3 class="text-lg font-semibold text-gray-800 mb-6">Ticket Options</h3>
    
        <div class="w-full grid grid-cols-1 gap-6">
          <div *ngFor="let ticket of item.tickets"
            class="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-gray-100 last:border-0 w-full pb-4">
    
            <!-- Ticket Category -->
            <div class="flex-1 min-w-0 text-sm text-gray-600">
              <span class="block md:inline truncate">{{ ticket.category }}</span>
            </div>
    
            <!-- Price and Stock -->
            <div class="flex items-center gap-4 text-sm">
              <span class="text-gray-600 whitespace-nowrap">
                R {{ ticket.sell | number: '1.2-2' }}
              </span>
              <span [ngClass]="{
                  'bg-red-100 text-red-800': ticket.stock === 0,
                  'bg-green-100 text-green-800': ticket.stock > 5,
                  'bg-yellow-100 text-yellow-800': ticket.stock <= 5 && ticket.stock > 3,
                  'bg-pink-100 text-pink-800': ticket.stock <= 3 && ticket.stock > 0
                }" class="px-3 py-1 text-xs tracking-wide rounded-full whitespace-nowrap">
                {{ ticket.stock === 0 ? 'Sold out' : (ticket.stock + ' left') }}
              </span>
            </div>
    
            <!-- Send Button -->
            <div class="flex justify-end md:justify-start">
              <button type="submit" (click)="openSecondModal(ticket)"
                class="flex items-center py-1 px-4 rounded-lg hover:bg-primary-500 border-2 border-accent-500 hover:border-primary-500 hover:text-white transition-all duration-300 text-sm"
                [disabled]="ticket.stock === 0">
                <span *ngIf="!isSubmitting">Enquire</span>
                <span *ngIf="isSubmitting">Sending...</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- <form (ngSubmit)="submitEnquiry()"> -->
    <!-- Status Message -->
    <!-- <div *ngIf="statusMessage" class="mb-4 p-3 bg-yellow-100 text-yellow-800 rounded">
        {{statusMessage}}
      </div> -->

    <!-- Name & Surname -->
    <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="block text-sm font-medium mb-1">First Name *</label>
          <input type="text" placeholder="Your Name" class="border border-gray-300 rounded px-4 py-2 w-full" 
                [(ngModel)]="enquiryForm.name" name="name" required />
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Last Name *</label>
          <input type="text" placeholder="Your Surname" class="border border-gray-300 rounded px-4 py-2 w-full" 
                [(ngModel)]="enquiryForm.surname" name="surname" required />
        </div>
      </div> -->

    <!-- Email & Phone -->
    <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="block text-sm font-medium mb-1">Email *</label>
          <input type="email" placeholder="your@email.com" class="border border-gray-300 rounded px-4 py-2 w-full" 
                [(ngModel)]="enquiryForm.email" name="email" required />
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Phone *</label>
          <input type="tel" placeholder="Phone number" class="border border-gray-300 rounded px-4 py-2 w-full" 
                [(ngModel)]="enquiryForm.phone" name="phone" required />
        </div>
      </div> -->

    <!-- Departure Date & Number of Nights -->
    <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="block text-sm font-medium mb-1">Departure Date *</label>
          <input type="date" class="border border-gray-300 rounded px-4 py-2 w-full" 
                [(ngModel)]="enquiryForm.departureDate" name="departureDate" required />
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Number of Nights *</label>
          <div class="flex items-center border border-gray-300 rounded overflow-hidden">
            <button type="button" (click)="decrement('nights')" class="px-3 py-2 bg-gray-100 hover:bg-gray-200">-</button>
            <input type="number" [(ngModel)]="enquiryForm.nights" name="nights" 
                  class="text-center w-full px-4 py-2 border-x border-gray-300" min="1" />
            <button type="button" (click)="increment('nights')" class="px-3 py-2 bg-gray-100 hover:bg-gray-200">+</button>
          </div>
        </div>
      </div> -->

    <!-- Guests -->
    <!-- <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div>
          <label class="block text-sm font-medium mb-1">Adults *</label>
          <div class="flex items-center border border-gray-300 rounded overflow-hidden">
            <button type="button" (click)="decrement('adults')" class="px-3 py-2 bg-gray-100 hover:bg-gray-200">-</button>
            <input type="number" [(ngModel)]="enquiryForm.adults" name="adults" 
                  class="text-center w-full px-4 py-2 border-x border-gray-300" min="1" />
            <button type="button" (click)="increment('adults')" class="px-3 py-2 bg-gray-100 hover:bg-gray-200">+</button>
          </div>
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Children <span class="text-xs text-gray-500">(under 12)</span></label>
          <div class="flex items-center border border-gray-300 rounded overflow-hidden">
            <button type="button" (click)="decrement('children')" class="px-3 py-2 bg-gray-100 hover:bg-gray-200">-</button>
            <input type="number" [(ngModel)]="enquiryForm.children" name="children" 
                  class="text-center w-full px-4 py-2 border-x border-gray-300" min="0" />
            <button type="button" (click)="increment('children')" class="px-3 py-2 bg-gray-100 hover:bg-gray-200">+</button>
          </div>
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Infants <span class="text-xs text-gray-500">(under 2)</span></label>
          <div class="flex items-center border border-gray-300 rounded overflow-hidden">
            <button type="button" (click)="decrement('infants')" class="px-3 py-2 bg-gray-100 hover:bg-gray-200">-</button>
            <input type="number" [(ngModel)]="enquiryForm.infants" name="infants" 
                  class="text-center w-full px-4 py-2 border-x border-gray-300" min="0" />
            <button type="button" (click)="increment('infants')" class="px-3 py-2 bg-gray-100 hover:bg-gray-200">+</button>
          </div>
        </div>
      </div> -->

    <!-- Comments -->
    <!-- <div class="mb-4">
        <label class="block text-sm font-medium mb-1">Special Requirements</label>
        <textarea rows="3" placeholder="Any special requirements?" class="border border-gray-300 rounded px-4 py-2 w-full"
                  [(ngModel)]="enquiryForm.comments" name="comments"></textarea>
      </div> -->

    <!-- Send Button -->
    <!-- <div class="flex justify-end">
        <button type="submit" class="bg-primary-500 text-white px-6 py-2 rounded hover:bg-primary-700 disabled:bg-blue-300"
                [disabled]="isSubmitting">
          <span *ngIf="!isSubmitting">Send Enquiry</span>
          <span *ngIf="isSubmitting">Sending...</span>
        </button>
      </div> -->
    <!-- </form> -->
  </div>
</div>